// extracted by mini-css-extract-plugin
export default {"cont":"index_cont__2IECd","big_title":"index_big_title__09HAc","item":"index_item__dq8Zt","right":"index_right__L397b","left":"index_left__YXD88"};